import React from "react";
import { Card as MuiCard, CardContent as MuiCardContent } from "@mui/material";
import { useTheme } from "../../theme/ThemeContext";

export const Card = ({
  children,
  variant = "elevation",
  sx = {},
  ...props
}) => {
  const theme = useTheme();
  const getCardStyles = () => {
    const baseStyles = {
      borderRadius: 2,
      overflow: "hidden",
    };

    if (variant === "product") {
      return {
        ...baseStyles,
        backgroundColor: theme?.homepage_product_card_background,
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
        transition: "all 0.3s ease",
        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: "0 8px 25px rgba(0, 0, 0, 0.15)",
        },
      };
    }

    return {
      ...baseStyles,
      backgroundColor: theme?.card_bg_color,
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    };
  };

  return (
    <MuiCard
      sx={{
        ...getCardStyles(),
        ...sx,
      }}
      {...props}
    >
      {children}
    </MuiCard>
  );
};

// Card content component
export const CardContentWrapper = ({ children, ...props }) => {
  const theme = useTheme();
  return (
    <MuiCardContent
      sx={{
        backgroundColor: theme?.homepage_product_name_background,
        "&:last-child": {
          paddingBottom: "8px",
        },
      }}
      {...props}
    >
      {children}
    </MuiCardContent>
  );
};

export default Card;
